// Cloud configuration — values injected via .env at build time
export const CLOUD_CONFIG = {
  region: import.meta.env.VITE_AWS_REGION as string,
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string,
  identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID as string,
  bucketName: import.meta.env.VITE_S3_BUCKET_NAME as string,
};

export const isCloudEnabled = () =>
  !!(
    CLOUD_CONFIG.region &&
    CLOUD_CONFIG.userPoolId &&
    CLOUD_CONFIG.clientId &&
    CLOUD_CONFIG.identityPoolId &&
    CLOUD_CONFIG.bucketName
  );

// S3 path prefixes
export const PATHS = {
  personal: (identityId: string) => `users/${identityId}/`,
  shared: () => `shared/`,
} as const;

export const isSharedKey = (key: string): boolean =>
  key.startsWith(PATHS.shared());
